<template>
  <div class="input-container">
    <div v-if="header" class="input__header">
      {{ header }}&nbsp;
      <span v-if="required">*</span>
      <div v-if="message" class="message" :class="message.type">
        <div class="message-icon">!</div>
        <div class="message-text">{{ message.text }}</div>
      </div>
    </div>
    <div class="input-block">
      <input
        v-if="type === 'tel'"
        ref="input"
        v-model="text"
        v-mask="mask"
        :maxlength="maxLength"
        :autocomplete="autocompleteString"
        :type="inputType"
        :name="name"
        class="input-field"
        :placeholder="placeholder"
        :disabled="disabled"
        @keypress.enter="enterHandler"
        @input="inputHandler"
        @change="changeHandler"
      />
      <textarea
        v-else-if="type === 'textarea'"
        ref="input"
        v-model="text"
        class="input-field input-textarea"
        :placeholder="placeholder"
        :disabled="disabled"
        :rows="rows"
        :name="name"
        @keypress.enter="enterHandler"
        @input="inputHandler"
      />
      <input
        v-else
        ref="input"
        v-model="text"
        :maxlength="maxLength"
        :autocomplete="autocompleteString"
        :type="inputType"
        class="input-field"
        :placeholder="placeholder"
        :disabled="disabled"
        :name="name"
        @keypress.enter="enterHandler"
        @input="inputHandler"
        @change="changeHandler"
      />
      <div
        v-if="type === 'password'"
        class="show-password icon"
        :class="{ blind: passwordShow }"
        @click="changeShowPassword"
      />
      <input
        v-if="type === 'password'"
        v-model="passwordShow"
        :name="name"
        type="checkbox"
        style="display: none"
        @change="changeShow"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputWithHeader',
  props: {
    message: [String, Boolean, Number],
    startText: {
      default: ''
    },
    maxLength: [String, Number],
    autocomplete: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    header: String,
    disabled: Boolean,
    required: Boolean,
    rows: {
      type: [String, Number],
      default: 3
    },
    name: String
  },
  data() {
    return {
      text: '',
      passwordShow: false,
      inputType: 'text',
      uniqueId: '',
      autocompleteString: true
    }
  },
  computed: {
    mask() {
      if (this.type === 'tel') {
        return '+7(###)###-##-##'
      } else {
        return ''
      }
    },
    customType() {
      if (this.type !== 'password') {
        return this.type
      }
      if (this.passwordShow) {
        return 'text'
      } else {
        return 'password'
      }
    }
  },
  beforeMount() {},
  mounted() {
    this.init()
    if (!this.autocomplete) {
      this.autocompleteString = 'new-password'
    }
  },
  methods: {
    init() {
      this.inputType = this.type
      if (this.inputType === 'date' || this.inputType === 'datetime-local') {
        if (this.startText !== '') {
          if (typeof this.startText !== 'string') {
            let date = new Date(Number.parseInt(this.startText))
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            if (month < 10) {
              month = '0' + month
            }
            let day = date.getDate()
            if (day < 10) {
              day = '0' + day
            }
            this.text = year + '-' + month + '-' + day //2017-07-04T08:30;
          } else {
            this.text = this.startText
          }
        }
      } else {
        this.text = this.startText
      }
    },
    changeShowPassword() {
      this.passwordShow = !this.passwordShow
      this.changeShow()
    },
    changeShow() {
      if (this.passwordShow) {
        this.inputType = 'text'
      } else {
        this.inputType = 'password'
      }
    },
    enterHandler() {
      this.$emit('enterHandler')
    },
    changeHandler() {
      this.$emit('changeHandler', this.text)
    },
    inputHandler() {
      this.$emit('inputHandler', this.text)
    }
  }
}
</script>

<style lang="scss" scoped>
.message.success .message-icon {
  background: linear-gradient(180deg, #37c489 0%, #00cccc 100%);
}

.message.error .message-icon {
  background-color: #d65959;
}

.message-icon {
  text-shadow: 1px 1px 0px rgba(0, 0, 0, 0.25);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #cccccc;
  color: white;
  display: flex;
  font-size: 13px;
  line-height: 18;
  align-items: center;
  justify-content: center;
}

.message-text {
  width: 190px;
  position: absolute;
  padding: 10px;
  display: none;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #cccccc;
  top: 22px;
  z-index: 99;
}

.message:hover .message-text {
  display: block;
}

.message {
  padding-left: 10px;
  position: relative;
}

.show-password.blind {
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='18' viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.4453 13.7949L17.379 17.7288C17.5586 17.9043 17.7998 18.0014 18.0509 18C18.3019 17.9986 18.542 17.8981 18.7196 17.7206C18.8972 17.5431 18.9984 17.3029 19 17.0518C19.0016 16.8007 18.9042 16.5596 18.7288 16.3799L15.3129 12.9638C16.4993 12.3247 17.5735 11.5239 18.5454 10.5834C18.8946 10.2459 19.2218 9.88578 19.5505 9.52403C19.6993 9.36027 19.8484 9.19618 20 9.03367C19.9483 8.96881 19.9003 8.90781 19.8545 8.84968L19.8545 8.84966L19.8545 8.84963C19.7572 8.72602 19.6702 8.61542 19.5791 8.50835C18.5782 7.33033 17.4161 6.33435 16.1134 5.50728C15.8544 5.34291 15.5913 5.18771 15.3238 5.04209L18.7288 1.63745C18.9042 1.45772 19.0016 1.21565 19 0.964535C18.9984 0.713418 18.8972 0.473197 18.7196 0.295695C18.542 0.118194 18.3019 0.0177262 18.0509 0.0163327C17.7998 0.0149391 17.5586 0.113039 17.379 0.288558L13.4561 4.2111C13.1277 4.09629 12.7933 3.99517 12.4526 3.90835C10.4488 3.3978 8.47802 3.51728 6.54835 4.19981L2.63728 0.288558C2.54911 0.198185 2.44355 0.125889 2.32736 0.0764866C2.21117 0.0270841 2.08661 0.000817566 1.96035 1.91026e-05C1.8341 -0.000779361 1.70811 0.0234604 1.59131 0.0713892C1.4745 0.119318 1.36866 0.190131 1.27935 0.279382C1.19004 0.368632 1.11939 0.474591 1.07138 0.591372C1.02336 0.708152 0.999315 0.83317 1.00002 0.959436C1.00072 1.0857 1.02615 1.21126 1.07546 1.3275C1.12476 1.44374 1.19721 1.5492 1.28751 1.63745L4.67758 5.02768C3.06359 5.89214 1.66031 7.06074 0.428079 8.4679C0.331428 8.57851 0.235518 8.68987 0.139685 8.80114L-0.000488281 8.9637V9.04023C0.0405602 9.08768 0.0816665 9.13495 0.122737 9.18218L0.122878 9.18234C0.208102 9.28035 0.293169 9.37818 0.377241 9.477C1.38251 10.6605 2.54741 11.6625 3.85552 12.4934C4.12751 12.6662 4.4041 12.829 4.68549 12.9813L1.28751 16.3799C1.11214 16.5596 1.01474 16.8007 1.01633 17.0518C1.01791 17.3029 1.11804 17.5431 1.29566 17.7206C1.47328 17.8981 1.71334 17.9986 1.96443 18C2.21552 18.0014 2.4577 17.9043 2.63728 17.7288L6.55809 13.8072C6.87172 13.9155 7.1909 14.011 7.51583 14.0934C9.5642 14.6127 11.5347 14.4677 13.4453 13.7949ZM14.2704 11.9212L13.8964 11.5473C14.3853 10.7978 14.6426 9.95209 14.6429 9.00579C14.6433 8.06188 14.3891 7.21775 13.8956 6.47018L14.2934 6.07244C15.6389 6.7751 17.4439 8.11487 18.1409 9.01563C16.9982 10.2089 15.7285 11.2013 14.2704 11.9212ZM13.2568 7.10898C13.9418 8.28151 13.9537 9.7121 13.2576 10.9084L12.3154 9.96615C12.5763 9.34429 12.5649 8.6542 12.316 8.0497L13.2568 7.10898ZM11.9238 5.74326C11.4706 5.47032 10.9635 5.30347 10.4092 5.24271C9.55259 5.14893 8.77839 5.32277 8.08183 5.73336L9.02417 6.67575C9.61025 6.4353 10.3273 6.40764 10.9793 6.68765L11.9238 5.74326ZM7.9858 8.33606L5.71571 6.06587C4.5502 6.64944 3.4969 7.40507 2.53265 8.29898C2.36888 8.4509 2.21064 8.60833 2.04941 8.76874L2.04938 8.76877L2.04933 8.76882C1.97272 8.84504 1.89543 8.92194 1.81655 8.99923C2.97669 10.2121 4.25914 11.2139 5.72981 11.9368L6.09643 11.5701C5.38796 10.4929 5.17186 9.27747 5.45281 7.90923C5.75729 7.96061 6.02569 8.00598 6.30721 8.05409C6.05901 9.16507 6.26891 10.1536 6.73321 10.9332L7.67208 9.99413C7.43903 9.45748 7.39431 8.84581 7.59016 8.27003C7.7222 8.29205 7.85386 8.31403 7.9858 8.33606ZM9.03009 11.3348L8.08687 12.2782C8.26894 12.3847 8.45757 12.4742 8.64957 12.5453C9.75992 12.9564 10.9543 12.8281 11.9139 12.2634L10.9712 11.3206C10.3668 11.5803 9.6693 11.6017 9.03009 11.3348Z' fill='url(%23paint0_linear_49_8470)'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_49_8470' x1='9.99977' y1='0' x2='9.99977' y2='18' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2337C489'/%3E%3Cstop offset='1' stop-color='%2300CCCC'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
}

.show-password {
  cursor: pointer;
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='11' viewBox='0 0 20 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0.139685 5.3012C0.0929682 5.35544 0.0462693 5.40966 -0.000488281 5.46376V5.54029C0.0406075 5.58779 0.0817612 5.63512 0.122878 5.6824C0.208102 5.78041 0.293169 5.87824 0.377241 5.97706C1.38251 7.16054 2.54741 8.16253 3.85552 8.99343C4.9909 9.715 6.20663 10.2616 7.51583 10.5935C10.0211 11.2287 12.4099 10.8701 14.7151 9.76748C16.1413 9.08581 17.4128 8.17948 18.5454 7.08346C18.8946 6.74592 19.2218 6.38584 19.5505 6.02409C19.6993 5.86033 19.8484 5.69624 20 5.53373C19.9483 5.46887 19.9003 5.40786 19.8545 5.34972C19.7573 5.22611 19.6702 5.11549 19.5791 5.00841C18.5782 3.83039 17.4161 2.83441 16.1134 2.00734C14.9775 1.28632 13.7612 0.741866 12.4526 0.408414C10.4037 -0.113629 8.38937 0.0230311 6.41818 0.746786C4.04849 1.61704 2.08386 3.07712 0.428079 4.96796C0.331428 5.07857 0.235518 5.18993 0.139685 5.3012ZM8.64957 9.04536C7.12608 8.48123 5.81468 6.75876 6.30721 4.55415C6.02569 4.50604 5.75729 4.46067 5.45281 4.40929C5.09913 6.13176 5.53316 7.61207 6.74561 8.87918C4.83893 8.1516 3.23618 6.98343 1.81655 5.49929C1.89544 5.42199 1.97275 5.34507 2.04938 5.26883C2.21062 5.10842 2.36887 4.95097 2.53265 4.79904C3.73909 3.68061 5.08492 2.77865 6.61551 2.15931C6.77787 2.09371 6.87134 2.11667 6.97411 2.25333C7.05997 2.36793 7.1576 2.47364 7.25922 2.58366C7.30447 2.63265 7.35052 2.6825 7.39667 2.73438C8.26036 1.97236 9.26071 1.61704 10.4092 1.74277C11.3068 1.84116 12.0808 2.2178 12.7024 2.87268C13.9564 4.19337 14.1247 6.11317 13.1348 7.60605C12.1661 9.06613 10.3135 9.66143 8.64957 9.04536ZM13.2009 2.13034C14.3811 2.38015 17.2225 4.32893 18.1409 5.51569C16.7328 6.98616 15.1316 8.1516 13.2228 8.87809C14.1466 7.94005 14.6424 6.81998 14.6429 5.50585C14.6435 4.18954 14.1488 3.06728 13.2009 2.13034ZM9.47991 5.08605C8.8141 4.97453 8.20623 4.87286 7.59016 4.77009C7.19002 5.94646 7.79406 7.27261 8.95677 7.80286C10.1315 8.33802 11.526 7.87884 12.1792 6.74128C12.8215 5.62339 12.4936 4.18627 11.4227 3.43519C10.3562 2.68683 8.9524 2.94321 8.25324 3.69976C8.50242 3.98158 8.75224 4.26384 9.01086 4.55604C9.16358 4.72859 9.31937 4.9046 9.47991 5.08605Z' fill='url(%23paint0_linear_49_8465)'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_49_8465' x1='9.99977' y1='0.0935059' x2='9.99977' y2='10.9066' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2337C489'/%3E%3Cstop offset='1' stop-color='%2300CCCC'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
  width: 20px;
  right: 20px;
  height: 18px;
}

.success .input-field {
  border: 1px solid #1cc8ab;
}

.warning .input-field {
  border: 1px solid #d65959;
}

.input-field {
  font-size: 14px;
  height: 40px;
  padding: 0 14px;
  background: #ffffff;
  width: 100%;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  border-radius: 3px;

  &:disabled,
  &.disabled {
    background: #f2f2f2;
  }
}

.input-textarea {
  padding-top: 12px;
  padding-bottom: 12px;
  resize: none;
  height: auto;
}

.input-block {
  position: relative;
  display: flex;
  align-items: center;
}

.input__header span {
  color: #e72222;
}

.input__header {
  padding-bottom: 9px;
  font-size: 14px;
  display: flex;
  line-height: 19px;
  color: #666666;
}
</style>
